import { useTranslation } from 'react-i18next';
import { styled } from 'goober';

import { modalState } from '@/state/modal.state';
import { Inline } from '@/ui/line/line';
import { ParagraphSmall } from '@/ui/typography/widgets';

import type { ExampleCompany } from '../explore.state';

import { ExampleCompanyItem } from './example-company-item';
import { useSetAtom } from 'jotai';
import type { Dispatch, SetStateAction } from 'react';

export const ExampleCompaniesSelect = ({
  exampleCompanies,
  fieldBackground,
  setExampleCompanies,
  withBorder,
}: {
  exampleCompanies: ExampleCompany[];
  fieldBackground?: string;
  setExampleCompanies: Dispatch<SetStateAction<ExampleCompany[]>>;
  withBorder?: boolean;
}) => {
  const { t } = useTranslation('explore');
  const setModalState = useSetAtom(modalState);

  return (
    <Container
      $fieldBackground={fieldBackground}
      $withBorder={withBorder}
      alignItems="center"
      justifyContent="flex-start"
      onClick={event => {
        event.stopPropagation();
        setModalState({
          state: 'addExampleCompaniesToExploreForm',
          exampleCompanies,
          setExampleCompanies,
        });
      }}
    >
      {exampleCompanies.length ? (
        exampleCompanies.map(company => (
          <ExampleCompanyItem
            key={company.id}
            company={company}
            setExampleCompanies={setExampleCompanies}
          />
        ))
      ) : (
        <Placeholder>{t`searchByCompanyName`}</Placeholder>
      )}
    </Container>
  );
};

const Placeholder = styled(ParagraphSmall)`
  padding: 5px 0;
  color: ${({ theme }) => theme.colors.gray.c10};
`;

const Container = styled(Inline)<{
  $fieldBackground?: string;
  $withBorder?: boolean;
}>`
  padding: 8px 10px;
  border-radius: ${({ $withBorder }) => ($withBorder ? '8px' : '10px')};
  background-color: ${({ $fieldBackground, theme }) =>
    $fieldBackground ?? theme.palettes.component.explore.form.background};
  ${({ $withBorder, theme }) =>
    $withBorder &&
    `
    border: 1px solid ${theme.colors.gray.c4};
    min-height: 44px;
  `}

  &:hover {
    cursor: pointer;
  }
`;
